import { TprReasonsApiService } from './../tpr-reasons-modal.service';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'tpr-add-reason',
  templateUrl: './tpr-add-reason.component.html',
})
export class TprAddReasonComponent {

  hoverInfo: { title: string, data: string }[] = [];

  reasonCodes: { reasonCode: string, id: number }[] = this.data.reasonCodes;

  form: UntypedFormGroup = new UntypedFormGroup({
    tprToolId: new UntypedFormControl(this.data.toolId, Validators.required),
    reasonCodeId: new UntypedFormControl(null, Validators.required),
    rationale: new UntypedFormControl(null, Validators.maxLength(325)),
    desStart: new UntypedFormControl(false),
    desFinish: new UntypedFormControl(false),
    bldStart: new UntypedFormControl(false),
    bldFinish: new UntypedFormControl(false)
  });

  @ViewChild('hoveroverlay') hoverOverlay: OverlayPanel;

  constructor(
    private readonly dialog: MatDialogRef<TprAddReasonComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: {
      reasonCodes: { reasonCode: string, id: number }[],
      toolId: number
    },
    private readonly service: TprReasonsApiService
  ) { }

  save() {
    this.service.createTprReason(this.form.value)
      .subscribe(() => this.dialog.close(true));
  }

  handleHoverEnter(event: any, reasonCd: any) {
    this.hoverInfo = [
      { title: 'Reason Code', data: reasonCd.reasonCode },
      { title: 'Area', data: reasonCd.area },
      { title: 'Desc', data: reasonCd.description },
      { title: 'Design Late Finish', data: reasonCd.designLateFinish },
      { title: 'Construction Late Finish', data: reasonCd.constLateFinish },
    ];

    if (this.hoverInfo && this.hoverInfo.length > 0) {
      this.hoverOverlay.show(event, event.target);
    }
  }

  handleHoverLeave() {
    this.hoverOverlay.hide();
  }
}
